// import logo from './logo.svg';
import './App.css';
import React from 'react';
import RouterConfig from './route'
import intl from 'react-intl-universal';
import en from './locales/en_US'
import zh from './locales/zh_CN'


const locales = {
  "en": en,
  "zh": zh,
};

class App extends React.Component {
  state = { initDone: false }
  componentDidMount() {
    let lang = (navigator.language || navigator.browserLanguage).toLowerCase();
    if (lang.indexOf('zh') >= 0) {
      // 假如浏览器语言是中文
      localStorage.setItem("defaultLng", "zh")
    } else {
      // 假如浏览器语言是其它语言
      localStorage.setItem("defaultLng", "en")
    }

    this.loadLocales();
  }

  loadLocales() {
    intl.init({
      currentLocale: localStorage.getItem('locale') || localStorage.getItem("defaultLng") || 'zh',
      locales,
    })
      .then(() => {
        this.setState({ initDone: true });
      });
  }
  render() {
    return (
      this.state.initDone && <div>
        <RouterConfig />
        {/* {intl.get('SIMPLE')} */}
      </div>
    );
  }
}

export default App;
